<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h5 bg-warning text-white">
        Unselect Selected Items
      </v-card-title>
      
      <v-card-text class="pt-4">
        Are you sure you want to uncheck these {{ count }} selected items?
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey-darken-1"
          variant="text"
          @click="$emit('cancel')"
          :disabled="processing"
        >
          Cancel
        </v-btn>
        <v-btn
          color="warning"
          variant="elevated"
          @click="$emit('confirm')"
          :loading="processing"
        >
          Unselect All
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UnselectSelectedItemsDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      required: true
    },
    processing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel']
}
</script>
